module.exports = __webpack_public_path__ + "static/media/cl-box.76c7a7de.svg";